import { Modal } from 'bootstrap';

export function searchModalHelper(container) {
  const searchContainer = document.querySelector('.search-input'),
    input = container.querySelector('#searchModalInput'),
    modalContainer = container.querySelector('#searchModal');

  if (!input || !modalContainer) return;

  input.addEventListener('focus', () => {
    searchContainer.classList.add('focused');
  });

  input.addEventListener('blur', () => {
    searchContainer.classList.remove('focused');
  });

  modalContainer.addEventListener('shown.bs.modal', () => {
    input.focus();
  });

  // Show search modal on key CTRL+/
  document.addEventListener('keydown', (event) => {
    if (event.ctrlKey && event.key === '/') {
      event.preventDefault();

      // Show search modal
      showSearchModal();
    }
  });
}

export function showSearchModal(container) {
  var target = document.querySelector('#searchModal');

  if (container) target = container.querySelector('#searchModal');

  var modal = Modal.getOrCreateInstance(target);

  if (!modal) return;

  modal.show();
}
